// File: src/components/fans/LeaderboardScoringModal.js

import React from 'react';

const LeaderboardScoringModal = ({ isOpen, onClose, isDarkMode = false }) => {
  if (!isOpen) return null;

  return (
    <div 
      onClick={onClose}
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-xs animate-in fade-in duration-200 cursor-pointer"
    >
      {/* Modal Card */}
      <div 
        onClick={(e) => e.stopPropagation()} 
        className={`relative max-w-md w-full rounded-3xl p-6 md:p-8 shadow-2xl border space-y-5 animate-in zoom-in-95 duration-200 cursor-default ${
          isDarkMode 
            ? 'bg-slate-900 border-slate-800 text-white' 
            : 'bg-white border-slate-100 text-slate-900'
        }`}
      >
        {/* Header */}
        <div className="flex items-center justify-between border-b border-slate-100 dark:border-slate-800 pb-3">
          <div className="flex items-center gap-2">
            <span className="w-6 h-6 rounded-full bg-[#ff00cc]/10 text-[#ff00cc] flex items-center justify-center text-xs font-black">
              i
            </span>
            <h3 className="text-base font-black uppercase tracking-tight text-slate-800 dark:text-white">
              How Monthly Points Work
            </h3>
          </div>
          <button
            onClick={onClose}
            className="w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold text-slate-400 hover:text-slate-600 dark:hover:text-white hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
          >
            ✕
          </button>
        </div>

        {/* Grade 7 Level Friendly Explanation */}
        <div className="space-y-4 text-xs md:text-sm text-slate-600 dark:text-slate-300 leading-relaxed font-medium">
          <p>
            Ever notice how some leaderboards completely wipe out everyone's score on the 1st day of the month? That makes rankings jump around like crazy!
          </p>

          <p>
            To keep things fair and smooth, our leaderboard uses a <strong>continuous rolling momentum</strong> score:
          </p>

          <div className="bg-slate-50 dark:bg-slate-800/50 p-3.5 rounded-2xl border border-slate-100 dark:border-slate-800 space-y-2 text-xs">
            <div className="flex items-start gap-2">
              <span className="text-[#22c55e] font-black text-sm leading-none">•</span>
              <p>
                <strong>New points matter most:</strong> Any tips received during the current month count right away at 100% value.
              </p>
            </div>
            <div className="flex items-start gap-2">
              <span className="text-[#3b82f6] font-black text-sm leading-none">•</span>
              <p>
                <strong>Last month's support carries over:</strong> Points from last month stay with you early in the month so your score doesn't suddenly drop to zero.
              </p>
            </div>
            <div className="flex items-start gap-2">
              <span className="text-[#ff00cc] font-black text-sm leading-none">•</span>
              <p>
                <strong>Gentle fade:</strong> As the new month moves forward, older points gradually fade away as your newest tips take over.
              </p>
            </div>
          </div>

          <p className="text-[11px] text-slate-400 italic">
            This ensures artists and fans who work hard all month keep their steady momentum without sudden drops!
          </p>
        </div>

        {/* Action Button */}
        <button
          onClick={onClose}
          className="w-full py-3 bg-[#ff00cc] hover:bg-[#e000b4] text-white rounded-xl text-xs font-black uppercase tracking-wider shadow-lg shadow-[#ff00cc]/25 active:scale-95 transition-all"
        >
          Got it!
        </button>
      </div>
    </div>
  );
};

export default LeaderboardScoringModal;